var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowDateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.27121 6.12832H14.4766M3.57478 0.414062V2.12855M15.0391 0.414062V2.12834M18.4141 4.61353L18.4141 17.9289C18.4141 19.3014 17.3014 20.4141 15.9289 20.4141H2.89925C1.52672 20.4141 0.414062 19.3014 0.414062 17.9289V4.61353C0.414062 3.241 1.52672 2.12834 2.89925 2.12834H15.9289C17.3014 2.12834 18.4141 3.241 18.4141 4.61353Z",
    stroke: "#FFD700",
    strokeWidth: 0.828396,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowDateIcon);
export default __webpack_public_path__ + "static/media/YellowDateIcon.56bd67c8d3a7ea6e3c61528d34c42e63.svg";
export { ForwardRef as ReactComponent };